import React from "react";
import { Row, Box } from "jsxstyle";
import get from "lodash/get";
import omit from "lodash/omit";
import pickBy from "lodash/pickBy";
import PrivateLayout from "components/PrivateLayout";
import Heading from "components/Heading";
import Separator from "components/Separator";
import Pagination from "components/Pagination";
import Button from "components/Button";
import Card from "components/Card";
import useAsync from "hooks/useAsync";
import useToast from "hooks/useToast";
import loadCLOService from "services/clo/loadCLOService";
import CLOFilters from "./CLOFilters";
import CLOTable from "./CLOTable";
import AddButton from "components/AddButton";
import useUrlParams from "hooks/useUrlParams";

const defaultParams = {
  page: 1,
  size: 20,
  order_by: "pricing_date",
  order_direction: "DESC",
};

function CLOListScreen({ history }) {
  const { showError } = useToast();

  const [params, setParams] = useUrlParams(defaultParams);

  const [fetch, pending, data, error] = useAsync({
    promiseFn: loadCLOService,
    params,
    eager: true,
  });

  React.useEffect(() => {
    if (error) {
      showError("Error loading ABS");
    }
  }, [error, showError]);

  return (
    <PrivateLayout>
      <Row alignItems="center">
        <Heading size="md">CLO</Heading>
        <Separator />
        <AddButton onClick={() => history.push("/clo/new")} />
      </Row>
      <Separator />
      <Card style={{ flexGrow: 1 }}>
        <Row
          justifyContent="space-between"
          alignItems="flex-start"
          flexWrap="wrap"
        >
          <Box flex={1}>
            <CLOFilters
              currentFilters={omit(params, ["page", "size"])}
              onChange={(newFilters) => {
                setParams({
                  ...pickBy(newFilters),
                  ...defaultParams,
                });
              }}
            />
          </Box>
          <Box flexBasis={150}>
            <Button
              icon="cog"
              text="Configure Table"
              onClick={() => history.push("/clo/table-configuration")}
            />
          </Box>
        </Row>
        <Separator />
        <CLOTable
          onSortChange={(sortObject) =>
            setParams({
              ...pickBy(sortObject),
              page: 1,
            })
          }
          onReload={fetch}
          data={get(data, "data", [])}
          pending={pending}
        />
        <Separator />
        {!pending && (
          <Row justifyContent="flex-end">
            <Pagination
              page={params.page}
              size={params.size}
              total={data.total}
              onChange={({ page }) => setParams({ ...params, page })}
            />
          </Row>
        )}
      </Card>
    </PrivateLayout>
  );
}

export default CLOListScreen;
